/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Button from "components/common_components/Button";
import Page from "components/common_components/Page/Page";
import useStyles from "./useStyles";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import InvoicingContext from "./InvoicingContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";

const headCells = [
    { index: 1, id: "consecutive", disablePadding: false, label: "#" },
    { index: 2, id: "clientName", disablePadding: true, label: "Client" },
    { index: 3, id: "issueDateString", orderBy: "issueDate", disablePadding: false, label: "Issue Date" },
    { index: 4, id: "totalAmount", disablePadding: false, type: "currency", label: "Total Amount", numeric: true },
];

function List({ history }) {
    const classes = useStyles();
    const { user } = useSelector((state) => state.Login);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);

    const { Invoices, setIsUserCreating } = useContext(InvoicingContext);

    function getInvoices(requestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Invoices.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getInvoices();
        setIsUserCreating(false);

        return () => {
            setData([]);
        };
    }, []);

    function onRowClickHandler(item) {
        history.push(`/invoicing/${item.id}/update`);
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getInvoices();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        Invoices.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  clientName: filterValue,
              }
            : {};
    }

    return (
        <Page className={classes.root}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Header title="Invoices">
                        <div className="button-group">
                            <Button primary onClick={() => history.push("/invoicing/add")}>
                                <Icon name="add" size="md" color="white" />
                                <span>Add</span>
                                
                            </Button>
                        </div>
                    </Header>
                    <div className="layout">
                        <EnhancedTable
                            headCells={headCells}
                            data={data}
                            title="Invoices"
                            defaultOrder={{ order: "desc", orderBy: "consecutive" }}
                            keyColumnName="id"
                            selectable={user.isAdmin}
                            deletable={user.isAdmin}
                            onRowClick={onRowClickHandler}
                            onDelete={user.isAdmin && onDeleteHandler}
                            onRequestData={getInvoices}
                            pageableData={pageableData}
                            defaultRowsPerPage={10}
                            filterBuilder={filterBuilder}
                        />
                    </div>
                </>
            )}
        </Page>
    );
}

List.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(List);
